/** Il contesto che la pagina della partita conclusa passa alle sue schede. */

import { useOutletContext } from 'react-router-dom';
import type { RispostaTabellino } from './Tabellino.js';

export interface ContestoPartita {
  /** Il tabellino della testata, anche per la scheda Tabellino; null finché arriva. */
  tabellino: RispostaTabellino | null;
  errore: string | null;
  /** Rilegge risultato, marcatori e carico: gli eventi corretti li cambiano. */
  ricarica: () => Promise<void>;
}

/** La partita conclusa della pagina, per le schede. */
export const usePartita = () => useOutletContext<ContestoPartita | undefined>();
